/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { React, useState, useEffect } from "react";
import axios from "axios";
import Table from "../components/Table";
import Alert from "../../src/components/Alert";
import { useHistory } from "react-router";
import styles from "./style.module.css";
import ReactDatePicker from "react-datepicker";
import makerChecker from "../assets/download.svg";
import constants from "../constants";

axios.defaults.base1URL = constants.BASE1_URL;

const Authoriser = () => {
	const history = useHistory();
	const token = localStorage.getItem("access_token");

	const [loading, setLoading] = useState(false);

	const [alldata, setAllData] = useState();

	const [esbn, setESBN] = useState("");
	const [customerName, setCusName] = useState("");
	const [branchName, setBankBranch] = useState("");
	const [billNumber, setBillNumber] = useState("");
	const [paymentMethod, setPayMth] = useState("");
	const [totalAmountPaid, setTAmount] = useState("");
	const [revenue, setRevenue] = useState("");
	const [payDate, setPaymentDate] = useState("");
	const [status, setStatus] = useState("");
	const [alert, setAlert] = useState({
		showing: false,
		type: null,
		message: ""
	});

	const headers = [
		["ESBN", "esbn"],
		["Customer Name", "customerName"],
		["Bank Branch", "branchName"],
		["Bill Number", "billNumber"],
		["Total Amount", "totalAmountPaid"],
		["Revenue", "revenue"],
		["Payment Date", "paymentDate"],
		["Status", "approveRejectFlag", getStatusText]
	];

	function getStatusText(approveRejectFlag) {
		if (approveRejectFlag === 0) {
			return "Pending";
		} else if (approveRejectFlag === 1) {
			return "Approved";
		} else {
			return "Denied";
		}
	}

	const getAllManualRecon = async () => {
		setLoading(true);

		try {
			const response = await axios.get(
				`${constants.BASE1_URL}/manualRecon/getAllManualReconRecords`,
				{
					headers: {
						Authorization: `Bearer ${token}`
					}
				}
			);

			const data = response.data;

			if (response) setLoading(false);

			if (response.status === 200) {
				setAllData(data.data);
				console.log(data);
			}
		} catch (error) {
			// Handle errors here
			setAlert({
				...alert,
				showing: true,
				type: "error",
				message: "Data Not Found"
			});
		}
	};
	console.log(loading);

	useEffect(() => {
		getAllManualRecon();
	}, []);

	useEffect(() => {
		const delay = setTimeout(
			() =>
				setAlert({
					showing: false,
					type: null,
					message: ""
				}),
			3000
		);

		return () => clearTimeout(delay);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [!!alert.showing]);

	return (
		<>
			<div>
				{alert.showing && (
					<Alert text={alert.message} type={alert.type} />
				)}
				<div>
					<div className={[styles.download__rpt].join("")}>
						<div>
							<img src={makerChecker} alt="maker" />
						</div>
						<label
							htmlFor="date-filter"
							className={[styles.label].join("")}
						>
							Download Report
						</label>
					</div>
					<form className={[styles.header__side].join(" ")}>
						<input
							type="name"
							placeholder="search"
							className={[styles.search__bar]}
						/>
						<select>
							<option>Bill Type</option>
						</select>
						<select>
							<option>Status</option>
						</select>
						{/* <Calendar /> */}
						<div>
							<ReactDatePicker />
						</div>
						<button
							className={[
								"primary__btn",
								styles.add__newbtns
							].join(" ")}
						>
							Search
						</button>
					</form>
				</div>
				<div>
					<div className="dashBoard">
						<Table
							headers={headers}
							data={alldata}
							full
							pageSize={20}
							onView={(data) => {
								history.push(`/maker-checker/view/${data.id}`);
							}}
						/>
					</div>
				</div>
			</div>
		</>
	);
};

export default Authoriser;
